import dayjs from "dayjs";

export const steps = [
  'Lipids', 'Buffers', 'Payload Phase', 'Encapsulant Phase', 'Mixing', 
  'Intermediate LNP Samples', 'Dilution','Purification', 'Antibiotics', 
  'Antibiotic Addition', 'Final LNP Samples',
];

export const initValues = {
  today: dayjs(Date.now()),
  lipids: {},
  supplierArray: [],
  operatorArray: [],
  productCodeArray: [],
  lotNumberArray: [],
  solventArray: [],
  buffer_id_list: ['02-07-2024-1-1', '02-07-2024-1-2', '02-07-2024-1-3'],
  buffer_acronym_list: ['Acronym 1', 'Acronym 2', 'Acronym 3', 'Acronym 4'],
  mixer_types_list: ['Janus', 'Ignite'],
};

export const materialsObj = {
  lipidArray: [],
  buffersArray: [],
  antibioticArray: [],
  payloadPhaseArray: [],
  encapsulantPhaseArray: [],
  mixingArray: [],
  intermediateLnpSampleArray: [],
  dilutionArray: [],
  purificationArray: [],
  antibioticAdditionArray: [],
  finalLNPSampleArray: [],
};

let aliquotIndex = 0;

export const getAliquotsIndex = () => {
  return aliquotIndex++;
};

export const createAliquotObj = () => ({
  index: getAliquotsIndex(),
  aliquot_id: '', 
  aliquot_operator: null, 
  date_aliquoted: null,
});

export const getMaterialsInitVals = (
  materialIndex, initialValues, defaultMixer, defaultPurificationMethod
) => ({
  'Lipids': {
    index: materialIndex.lipidIndex++,
    lipid_type: null,
    lipid_name: null,
    supplier: null,
    is_new_lipid: true,
    date_prepared: null, 
    product_code: '', 
    lot_number: '', 
    number_of_ionisable_groups: '', 
    number_of_aliquots: 1,
    aliquot_list: [{...createAliquotObj()}],
    lipd_stock_id: '', 
    solvent: '', 
    concentration: '', 
    stock_operator: null, 
    amount_prepared: '', 
  },
  'Buffers': {
    index: materialIndex.bufferIndex++,
    unique_id: '',
    operator: '',
    date_prepared: '',
    buffer_acronym: null,
    target_pH: '',
    measured_pH: '',
    buffer_concentration: '',
    buffer_component_1: '',
    buffer_component_1_concentration: '',
    buffer_component_2: '',
    buffer_component_2_concentration: '',
    buffer_component_3: '',
    buffer_component_3_concentration: '',
    buffer_component_4: '',
    buffer_component_4_concentration: '',
    buffer_component_5: '',
    buffer_component_5_concentration: '',
    buffer_component_6: '',
    buffer_component_6_concentration: '',
  },
  'Antibiotics': {
    index: materialIndex.antibioticIndex++,
    type: '',
    concentration: '',
  },
  'Payload Phase': {
    index: materialIndex.payloadPhaseIndex++,
    payload_name: '',
    payload_type: '',
    reporter: '',
    payload_batch_number: '',
    payload_phase_id: '',
    encapsulant_buffer_id: null,
    concentration: '',
    operator: null,
    encapsulant_buffer_acronym: null,
  },
  'Encapsulant Phase': {
    index: materialIndex.encapsulantPhaseIndex++,
    is_new_encapsulant_phase: true,
    lnp_sample_id: '',
    lnp_sample_name: '',
    operator: null,
    solvent: '',
    date_prepared: null,
    lipids: [],
  },
  'Mixing': {
    index: materialIndex.mixingIndex++,
    mixer: defaultMixer,
  },
  'Intermediate LNP Samples': {
    index: materialIndex.intermediateLNPSampleIndex++,
    lnp_sample_name: '',
    lnp_sample_replicate: '',
    encapsulant_phase_id: '',
    payload_phase_id: '',
    mixer_type: 
      initialValues?.mixer_types_list ? 
        initialValues?.mixer_types_list[0] : null,
    payload_concentration_after_mixing: '',
    encapsulant_phase_volume: '',
    payload_phase_volume: '',
    ratio_c_payload_phase_to_encapsulant_phase: '',
    ratio_r_encapsulant_phase_to_payload_phase: '',
    flow_rate_ratio_c_payload_phase_to_encapsulant_phase: '',
    flow_rate_ratio_r_encapsulant_phase_to_payload_phase: '',
  },
  'Dilution': {
    index: materialIndex.dilutionIndex++,
    dilution_buffer_type: '',
    dilution_factor: '',
    payload_concentration_after_dilution: '',
    volume_after_dilution: '',
  },
  'Purification': {
    index: materialIndex.purificationIndex++,
    method: defaultPurificationMethod,
  },
  'Antibiotic Addition': {
    index: materialIndex.antibioticAdditionIndex++,
    antibiotic_type: '',
    dilution_factor: '',
    payload_concentration_after_dilution: '',
    antibiotic_concentration: '',
  },
  'Final LNP Samples': {
    final_lnp_sample_name: '',
    final_payload_concentration_after_purification: '',
    volume_after_purification: '',
    buffer_name: '',
    buffer_unique_id: '',
  },
});

export const mixingObj = {
  'Ignite': {
    labware_type: '',
    mixer_type: '',
    cartridge_type: '',
    payload_phase_brand: '',
    payload_phase_volume: '',
    encapsulant_phase_brand: '',
    encapsulant_phase_volume: '',
    dilution_buffer_brand: '',
    dilution_buffer_volume: '',
    flow_ratio_c: '',
    flow_ratio_r: '',
    total_volume: '',
    start_waste: '',
    end_waste: '',
  },
  'Janus': {
    lnp_sample_name: '',
    labware_item_location: '',
    labware_type: '',
    pipette_tip_type: '',
    rna_labware_item: '',
    rna_labware_item_location: '',
    mixing_cycles: '',
    encapsulation_speed: '',
    dilution_speed: '',
    lnp_sample_replicate: '',
    lnp_plate_barcode: '',
  },
};

export const purificationObj = {
  'Ultracentrifugation': {
    ultracentrifuge_filter_type: '',
    membrane_type: '',
    starting_volume: '',
    target_volume: '',
    speed: '',
    tempertaure: '',
    time: '',
    final_concention: '',
  },
  'Dialysis': {
    dialysis_consumable_manufactuer: '',
    dialysis_consumable_product_code: '',
    dialysis_consumbale_volume: '',
    dialysis_buffer_volume: '',
    no_of_buffer_exchanges: '',
    time_for_buffer_exchange_1: '',
    time_for_buffer_exchange_2: '',
    time_for_buffer_exchange_3: '',
    tempertaure: '',
    final_concention: '',
  },
  'Sterile filtration': {
    sterile_filter_manufacturer: '',
    sterile_filter_product_code: '',
    sterile_filter_pore_diameter: '',
    sterile_filter_pore_membrane_material: '',
  },
};

export const validateLipids = (plateName, data) => {
  const minLength = 8;
  const errors = {};
  if (!plateName) {
    errors['plate_name'] = 'Plate Name is required!';
  } else if (plateName.length !== minLength) {
    errors['plate_name'] = `Plate Name must be ${minLength} characters long!`;
  }
  for (const item of data) {
    const index = item?.index;
    if (!item['lipid_type']) {
      errors[`lipid_type-${index}`] = 'Lipid type is required!';
    }
    if (!item['lipid_name']) {
      errors[`lipid_name-${index}`] = 'Lipid name is required!';
    }
    if (!item['supplier']) {
      errors[`supplier-${index}`] = 'Supplier is required!';
    }
    if (!item['product_code']) {
      errors[`product_code-${index}`] = 'Product code is required!';
    }
    if (!item['lot_number']) {
      errors[`lot_number-${index}`] = 'Lot number is required!';
    }
    if (!item['number_of_ionisable_groups']) {
      errors[`number_of_ionisable_groups-${index}`] = 'Number of ionisable groups is required!';
    }
    for (const aliquotItem of item?.aliquot_list) {      
      const aloquotIndex = aliquotItem?.index;
      if (!aliquotItem['aliquot_id']) {
        errors[`aliquot_id-${aloquotIndex}`] = 'Aliquot id is required!';
      }
      if (!aliquotItem['date_aliquoted']) {
        errors[`date_aliquoted-${aloquotIndex}`] = 'Date aliquoted is required!';
      }
      if (!aliquotItem['aliquot_operator']) {
        errors[`aliquot_operator-${aloquotIndex}`] = 'Operator is required!';
      }
    }
    if (!item['lipd_stock_id']) {
      errors[`lipd_stock_id-${index}`] = 'Lipd stock id is required!';
    }
    if (!item['solvent']) {
      errors[`solvent-${index}`] = 'Solvent is required!';
    }
    if (!item['concentration']) {
      errors[`concentration-${index}`] = 'Concentration is required!';
    }
    if (!item['date_prepared']) {
      errors[`date_prepared-${index}`] = 'Date prepared is required!';
    }
    if (!item['stock_operator']) {
      errors[`stock_operator-${index}`] = 'Operator is required!';
    }
    if (!item['amount_prepared']) {
      errors[`amount_prepared-${index}`] = 'Amount prepared is required!';
    }
  }
  return errors;
};

export const validateBuffers = data => {
  const errors = {};
  const regex = /^\d{2}-\d{2}-\d{4}-\d+-\d+$/;
  for (const item of data) {
    const index = item?.index;
    if (!item['unique_id']) {
      errors[`unique_id-${index}`] = 'Unique ID is required!';
    } else if (!regex.test(item['unique_id'])) {
      errors[`unique_id-${index}`] = 'This is not a valid Unique ID format!';
    }
    if (!item['operator']) {
      errors[`operator-${index}`] = 'Operator is required!';
    }
    if (!item['date_prepared']) {
      errors[`date_prepared-${index}`] = 'Date Prepared is required!';
    }
    if (!item['buffer_acronym']) {
      errors[`buffer_acronym-${index}`] = 'Buffer Acronym is required!';
    }
    if (!item['buffer_pH']) {
      errors[`buffer_pH-${index}`] = 'Buffer pH is required!';
    }
    if (!item['buffer_concentration']) {
      errors[`buffer_concentration-${index}`] = 'Buffer Concentration is required!';
    }
    if (!item['buffer_component_1']) {
      errors[`buffer_component_1-${index}`] = 'Buffer component 1 is required!';
    }
    if (!item['buffer_component_1_concentration']) {
      errors[`buffer_component_1_concentration-${index}`] = 'Buffer component 1 (concentration mM) is required!';
    }
    if (!item['buffer_component_2']) {
      errors[`buffer_component_2-${index}`] = 'Buffer component 2 is required!';
    }
    if (!item['buffer_component_2_concentration']) {
      errors[`buffer_component_2_concentration-${index}`] = 'Buffer component 2 (concentration mM) is required!';
    }
    if (!item['buffer_component_3']) {
      errors[`buffer_component_3-${index}`] = 'Buffer component 3 is required!';
    }
    if (!item['buffer_component_3_concentration']) {
      errors[`buffer_component_3_concentration-${index}`] = 'Buffer component 3 (concentration mM) is required!';
    }
    if (!item['buffer_component_4']) {
      errors[`buffer_component_4-${index}`] = 'Buffer component 4 is required!';
    }
    if (!item['buffer_component_4_concentration']) {
      errors[`buffer_component_4_concentration-${index}`] = 'Buffer component 4 (concentration mM) is required!';
    }
    if (!item['buffer_component_5']) {
      errors[`buffer_component_5-${index}`] = 'Buffer component 5 is required!';
    }
    if (!item['buffer_component_5_concentration']) {
      errors[`buffer_component_5_concentration-${index}`] = 'Buffer component 5 (concentration mM) is required!';
    }
    if (!item['buffer_component_6']) {
      errors[`buffer_component_6-${index}`] = 'Buffer component 6 is required!';
    }
    if (!item['buffer_component_6_concentration']) {
      errors[`buffer_component_6_concentration-${index}`] = 'Buffer component 6 (concentration mM) is required!';
    }
  }
  return errors;
};

export const validateAntibiotics = data => {
  const errors = {};
  for (const item of data) {
    const index = item?.index;
    if (!item['unique_id']) {
      errors[`unique_id-${index}`] = 'Unique ID is required!';
    }
    if (!item['type']) {
      errors[`type-${index}`] = 'Type is required!';
    }
    if (!item['concentration']) {
      errors[`concentration-${index}`] = 'Concentration is required!';
    }
  }
  return errors;
};

export const validatePayloadPhase = data => {
  const errors = {};
  for (const item of data) {
    const index = item?.index;
    if (!item['unique_id']) {
      errors[`unique_id-${index}`] = 'Unique ID is required!';
    }
    if (!item['payload_type']) {
      errors[`payload_type-${index}`] = 'Payload Type is required!';
    }
    if (!item['reporter']) {
      errors[`reporter-${index}`] = 'Reporter is required!';
    }
    if (!item['batch_number']) {
      errors[`batch_number-${index}`] = 'Batch Number is required!';
    }
    if (!item['payload_phase_id']) {
      errors[`payload_phase_id-${index}`] = 'Payload Phase ID is required!';
    }
    if (!item['buffer_id']) {
      errors[`buffer_id-${index}`] = 'Buffer id is required!';
    }
    if (!item['concentration']) {
      errors[`concentration-${index}`] = 'Concentration is required!';
    }
    if (!item['operator']) {
      errors[`operator-${index}`] = 'Operator is required!';
    }
  }
  return errors;
};

export const validateEncapsulantPhase = data => {
  const errors = {};
  for (const item of data) {
    const index = item?.index;
    if (!item['sample_name']) {
      errors[`sample_name-${index}`] = 'Sample Name is required!';
    }
    if (!item['operator']) {
      errors[`operator-${index}`] = 'Operator is required!';
    }
    if (!item['solvent']) {
      errors[`solvent-${index}`] = 'Solvent is required!';
    }
    if (!item['date_prepared']) {
      errors[`date_prepared-${index}`] = 'Date prepared is required!';
    }
  }
  return errors;
};

export const validateMixing = data => {
  const errors = {};
  for (const item of data) {
    const index = item?.index;
    const mixer = item?.mixer;
    if (!mixer) {
      errors[`mixer-${index}`] = 'Mixer is required!';
    }
    if (mixer === 'Janus') {
      if (!item['lnp_sample_name']) {
        errors[`lnp_sample_name-${index}`] = 'Sample Name is required!';
      }
      if (!item['labware_item_location']) {
        errors[`labware_item_location-${index}`] = 'Well ID is required!';
      }
      if (!item['labware_type']) {
        errors[`labware_type-${index}`] = 'Labware Type is required!';
      }
      if (!item['pipette_tip_type']) {
        errors[`pipette_tip_type-${index}`] = 'Tip Type is required!';
      }
      if (!item['rna_labware_item']) {
        errors[`rna_labware_item-${index}`] = 'AQ Labware is required!';
      }
      if (!item['rna_labware_item_location']) {
        errors[`rna_labware_item_location-${index}`] = 'AQ Well is required!';
      }
      if (!item['mixing_cycles']) {
        errors[`mixing_cycles-${index}`] = 'Mixing Cycles is required!';
      }
      if (!item['encapsulation_speed']) {
        errors[`encapsulation_speed-${index}`] = 'Encapsulation Speed is required!';
      }
      if (!item['dilution_speed']) {
        errors[`dilution_speed-${index}`] = 'Dilution Speed is required!';
      }
      if (!item['lnp_sample_replicate']) {
        errors[`lnp_sample_replicate-${index}`] = 'Sample Replicate is required!';
      }
      if (!item['lnp_plate_barcode']) {
        errors[`lnp_plate_barcode-${index}`] = 'LNP Plate Barcode is required!';
      }
    }
    if (mixer === 'Ignite') {
      if (!item['labware_type']) {
        errors[`labware_type-${index}`] = 'Labware Type - storage vessel is required!';
      }
      if (!item['mixer_type']) {
        errors[`mixer_type-${index}`] = 'Mixer Type is required!';
      }
      if (!item['cartridge_type']) {
        errors[`cartridge_type-${index}`] = 'NanoAssemblr® Ignite™ NxGen™ Cartridge Type is required!';
      }
      if (!item['payload_phase_brand']) {
        errors[`payload_phase_brand-${index}`] = 'Syringe Payload Phase - Brand is required!';
      }
      if (!item['payload_phase_volume']) {
        errors[`payload_phase_volume-${index}`] = 'Syringe Payload Phase - Volume (mL) is required!';
      }
      if (!item['encapsulant_phase_brand']) {
        errors[`encapsulant_phase_brand-${index}`] = 'Syringe Encapsulant Phase - Brand is required!';
      }
      if (!item['encapsulant_phase_volume']) {
        errors[`encapsulant_phase_volume-${index}`] = 'Syringe Encapsulant phase - Volume (mL) is required!';
      }
      if (!item['dilution_buffer_brand']) {
        errors[`dilution_buffer_brand-${index}`] = 'Syringe Dilution buffer - Brand is required!';
      }
      if (!item['dilution_buffer_volume']) {
        errors[`dilution_buffer_volume-${index}`] = 'Syringe Dilution Buffer - Volume (mL) is required!';
      }
      if (!item['flow_ratio_c']) {
        errors[`flow_ratio_c-${index}`] = 'Flow Rate Ratio C - Payload phase to encapsulant phase is required!';
      }
      if (!item['flow_ratio_r']) {
        errors[`flow_ratio_r-${index}`] = 'Flow Rate Ratio R - Encapsulant phase to payload phase is required!';
      }
      if (!item['total_volume']) {
        errors[`total_volume-${index}`] = 'Total Volume (mL) is required!';
      }
      if (!item['start_waste']) {
        errors[`start_waste-${index}`] = 'Start waste (mL) is required!';
      }
      if (!item['end_waste']) {
        errors[`end_waste-${index}`] = 'End waste (mL) is required!';
      }
    }
  }
  return errors;
};

export const validateIntermediateLNPSamples = data => {
  const errors = {};
  for (const item of data) {
    const index = item?.index;
    const material_type = item?.material_type;
    if (!item['lnp_sample_name']) {
      errors[`lnp_sample_name-${index}`] = 'LNP Sample Name is required!';
    }
    if (!item['lnp_sample_replicate']) {
      errors[`lnp_sample_replicate-${index}`] = 'LNP Sample Replicate is required!';
    }
    if (!item['encapsulant_phase_id']) {
      errors[`encapsulant_phase_id-${index}`] = 'Encapsulant Phase ID is required!';
    }
    if (!item['payload_phase_id']) {
      errors[`payload_phase_id-${index}`] = 'Payload Phase ID is required!';
    }
    if (!item['material_type']) {
      errors[`material_type-${index}`] = 'Material Type is required!';
    }
    if (!item['payload_concentration_after_mixing']) {
      errors[`payload_concentration_after_mixing-${index}`] = 'Payload Concentration after mixing is required!';
    }
    if (!item['encapsulant_phase_volume']) {
      errors[`encapsulant_phase_volume-${index}`] = 'Encapsulant Phase Volume is required!';
    }
    if (!item['payload_phase_volume']) {
      errors[`payload_phase_volume-${index}`] = 'Payload Phase Volume is required!';
    }
    if (material_type === 'Janus') {
      if (!item['ratio_c_payload_phase_to_encapsulant_phase']) {
        errors[`ratio_c_payload_phase_to_encapsulant_phase-${index}`] = 'Ratio C Payload Phase to Encapsulant Phase is required!';
      }
      if (!item['ratio_r_encapsulant_phase_to_payload_phase']) {
        errors[`ratio_r_encapsulant_phase_to_payload_phase-${index}`] = 'Ratio R Encapsulant Phase to Payload Phase is required!';
      }
    }
    if (material_type === 'Ignite') {
      if (!item['flow_rate_ratio_c_payload_phase_to_encapsulant_phase']) {
        errors[`flow_rate_ratio_c_payload_phase_to_encapsulant_phase-${index}`] = 'Flow Rate Ratio C Payload Phase to Encapsulant Phase is required!';
      }
      if (!item['flow_rate_ratio_r_encapsulant_phase_to_payload_phase']) {
        errors[`flow_rate_ratio_r_encapsulant_phase_to_payload_phase-${index}`] = 'Flow Rate Ratio R Encapsulant Phase to Payload Phase is required!';
      }
    }
  }
  return errors;
};

export const validateDilution = data => {
  const errors = {};
  for (const item of data) {
    const index = item?.index;
    if (!item['dilution_buffer_type']) {
      errors[`dilution_buffer_type-${index}`] = 'Dilution Buffer Type is required!';
    }
    if (!item['dilution_factor']) {
      errors[`dilution_factor-${index}`] = 'Dilution Factor is required!';
    }
    if (!item['payload_concentration_after_dilution']) {
      errors[`payload_concentration_after_dilution-${index}`] = 'Payload concentration after dilution is required!';
    }
    if (!item['volume_after_dilution']) {
      errors[`volume_after_dilution-${index}`] = 'Volume after dilution is required!';
    }
  }
  return errors;
};

export const validatePurification = data => {
  const errors = {};
  for (const item of data) {
    const method = item?.method;
    const index = item?.index;
    if (!method) {
      errors[`method-${index}`] = 'Purification Method is required!';
    }
    if (method === 'Ultracentrifugation') {
      if (!item['ultracentrifuge_filter_type']) {
        errors[`ultracentrifuge_filter_type-${index}`] = 'Ultracentrifuge - Filter Type is required!';
      }
      if (!item['membrane_type']) {
        errors[`membrane_type-${index}`] = 'Membrane Type is required!';
      }
      if (!item['starting_volume']) {
        errors[`starting_volume-${index}`] = 'Starting volume (mL) is required!';
      }
      if (!item['target_volume']) {
        errors[`target_volume-${index}`] = 'Target volume (mL) is required!';
      }
      if (!item['speed']) {
        errors[`speed-${index}`] = 'Speed (RCF) is required!';
      }
      if (!item['tempertaure']) {
        errors[`tempertaure-${index}`] = 'Tempertaure °C is required!';
      }
      if (!item['time']) {
        errors[`time-${index}`] = 'Time (minutes) is required!';
      }
      if (!item['final_concention']) {
        errors[`final_concention-${index}`] = 'Final concention (mg/ml) is required!';
      }
    } 
    if (method === 'Dialysis') {
      if (!item['dialysis_consumable_manufactuer']) {
        errors[`dialysis_consumable_manufactuer-${index}`] = 'Dialysis consumable manufactuer is required!';
      }
      if (!item['dialysis_consumable_product_code']) {
        errors[`dialysis_consumable_product_code-${index}`] = 'Dialysis consumable product code is required!';
      }
      if (!item['dialysis_consumbale_volume']) {
        errors[`dialysis_consumbale_volume-${index}`] = 'Dialysis consumbale volume (mL) is required!';
      }
      if (!item['dialysis_buffer_volume']) {
        errors[`dialysis_buffer_volume-${index}`] = 'Dialysis buffer volume (mL) is required!';
      }
      if (!item['no_of_buffer_exchanges']) {
        errors[`no_of_buffer_exchanges-${index}`] = 'No of buffer exchanges is required!';
      }
      if (!item['time_for_buffer_exchange_1']) {
        errors[`time_for_buffer_exchange_1-${index}`] = 'Time for buffer exchange 1 (hours) is required!';
      }
      if (!item['time_for_buffer_exchange_2']) {
        errors[`time_for_buffer_exchange_2-${index}`] = 'Time for buffer exchange 2 (hours) is required!';
      }
      if (!item['time_for_buffer_exchange_3']) {
        errors[`time_for_buffer_exchange_3-${index}`] = 'Time for buffer exchange 3 (hours) is required!';
      }
      if (!item['tempertaure']) {
        errors[`tempertaure-${index}`] = 'Tempertaure °C is required!';
      }
      if (!item['final_concention']) {
        errors[`final_concention-${index}`] = 'Final concention (mg/ml) is required!';
      }
    }
    if (method === 'Sterile filtration') {
      if (!item['sterile_filter_manufacturer']) {
        errors[`sterile_filter_manufacturer-${index}`] = 'Sterile filter manufacturer is required!';
      }
      if (!item['sterile_filter_product_code']) {
        errors[`sterile_filter_product_code-${index}`] = 'Sterile filter product code is required!';
      }
      if (!item['sterile_filter_pore_diameter']) {
        errors[`sterile_filter_pore_diameter-${index}`] = 'Sterile filter pore diameter (µm) is required!';
      }
      if (!item['sterile_filter_pore_membrane_material']) {
        errors[`sterile_filter_pore_membrane_material-${index}`] = 'Sterile filter pore membrane material is required!';
      }
    }
  }
  return errors;
};

export const validateAntibioticAddition = data => {
  const errors = {};
  for (const item of data) {
    const index = item?.index;
    if (!item['antibiotic_type']) {
      errors[`antibiotic_type-${index}`] = 'Antibiotic Type is required!';
    }
    if (!item['dilution_factor']) {
      errors[`dilution_factor-${index}`] = 'Dilution Factor is required!';
    }
    if (!item['payload_concentration_after_dilution']) {
      errors[`payload_concentration_after_dilution-${index}`] = 'Payload concentration after dilution is required!';
    }
    if (!item['antibiotic_concentration']) {
      errors[`antibiotic_concentration-${index}`] = 'Antibiotic concentration is required!';
    }
  }
  return errors;
};

export const validateFinalLNPSamples = data => {
  const errors = {};
  for (const item of data) {
    const index = item?.index;
    if (!item['final_lnp_sample_name']) {
      errors[`final_lnp_sample_name-${index}`] = 'Final LNP Samples is required!';
    }
    if (!item['final_payload_concentration_after_purification']) {
      errors[`final_payload_concentration_after_purification-${index}`] = 'Final payload concentration after purification is required!';
    }
    if (!item['volume_after_purification']) {
      errors[`volume_after_purification-${index}`] = 'Volume after purification is required!';
    }
    if (!item['buffer_name']) {
      errors[`buffer_name-${index}`] = 'Buffer Name is required!';
    }
    if (!item['buffer_unique_id']) {
      errors[`buffer_unique_id-${index}`] = 'Buffer Unique ID is required!';
    }
  }
  return errors;
};